import withAPIAction from 'helpers/withAPIAction'
import { ListReq, DetailReq, CreateReq, UpdateReq } from './types'
import { getListAction, createAction, updateAction, getDetailAction } from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { CreateMapping } from 'Store/common/common.types'

export const couponListAPI = (data: ListReq, token: string, xmid: string) => {
  return withAPIAction<ListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.couponList,
    data,
    token,
    xmid,
  })(getListAction)
}

export const createCouponAPI = (data: CreateMapping<CreateReq>, token: string, xmid: string) => {
  return withAPIAction<CreateMapping<CreateReq>>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createCoupon,
    data,
    token,
    xmid,
  })(createAction)
}

export const updateCouponAPI = (data: CreateMapping<UpdateReq>, token: string, xmid: string) => {
  return withAPIAction<CreateMapping<UpdateReq>>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateCoupon,
    data,
    token,
    xmid,
  })(updateAction)
}

export const getCouponDetailAPI = (data: DetailReq, token: string, xmid: string) => {
  return withAPIAction<DetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getCouponByID,
    data,
    token,
    xmid,
  })(getDetailAction)
}
